<template>
  <div class="drug-info substance">
    <div class="detail-info description">
      <span class="info-title">药剂：</span>
      <div class="drug-line">
        <span class="name">急诊手术室</span>
        <span class="number">{{ form.number1 || 0 }}</span>
        <span class="unit">个</span>
        <span class="name">急诊EICU</span>
        <span class="number">{{ form.number2 || 0 }}</span>
        <span class="unit">个</span>
        <span class="name">急诊综合病房</span>
        <span class="number">{{ form.number3 || 0 }}</span>
        <span class="unit">个</span>
      </div>
    </div>
    <div class="detail-info description">
      <span class="info-title">操作：</span>
      <div class="">{{ form.content }}</div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DrugLook",
  props: {},
  data() {
    return {
      form: {
        content: "",
        number1: "",
        number2: "",
        number3: ""
      }
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),

  },
  watch: {
    patient: {
      handler(val) {
        const { nobody_hospitalprepares } = val;
        if (nobody_hospitalprepares[0]) {
          const { content, rooms } = nobody_hospitalprepares[0];
          let number1, number2, number3;
          try {
            const jsonRoom = JSON.parse(rooms);
            number1 = jsonRoom.find((item) => {
              return item.name === "急诊手术室";
            })["amount"];
            number2 = jsonRoom.find((item) => {
              return item.name === "急诊EICU";
            })["amount"];
            number3 = jsonRoom.find((item) => {
              return item.name === "急诊综合病房";
            })["amount"];
          } catch (e) {
            number1 = 0;
            number2 = 0;
            number3 = 0;
          }
          this.form = {
            content,
            number1,
            number2,
            number3
          };
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped lang="scss">
.detail-info {
  display: flex;
}

.description {
  height: auto;
}

.drug-line {
  display: flex;
}

.info-title {
  width: 62px;
}

.drug-item {
  margin-right: 80px;
}

.drug-line {
  color: #666666;
  font-size: 16px;

  .number {
    margin-right: 10px;
    margin-left: 10px;
  }

  .unit + .name {
    margin-left: 35px;
  }
}
</style>
